<template>
    <NewFeeScheduleComp></NewFeeScheduleComp>
</template>

<script>
import NewFeeScheduleComp from '../../components/Fee2025/NewFeeSchedule.vue';

export default {
  name: "New Fee Schedule 2025",
  components: { NewFeeScheduleComp },
  computed: {},
  mounted() {},
};
</script>